import React, { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import "./Navigation.css";
// import logo from "../../assets/images/Logo-white.png";
import { IoMenuOutline } from "react-icons/io5";

function Navigation() {

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0 && expanded) {
        setExpanded(true);
      }

      if (expanded) {
        setExpanded(false);
      }
    }

    if (expanded) {
      window.addEventListener('scroll', handleScroll);
    }
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }

  }, [expanded]);


  const handleClick = () => {
    setExpanded(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleToggle = () => {
    if (window.scrollY > 0) {

      setExpanded(true)
      setTimeout(() => {
        setExpanded(true);
      }, 800);
    }
    else {
      setExpanded(!expanded)
    }
  }



  return (
    <Navbar collapseOnSelect expand="lg" className=" text-white bg-white p-1 shadow px-1" id="rescstomcss_1" expanded={expanded} style={{ background: '#0000' }}>

      <div className="logo-container" >
        <img className="logo-image p-1"
          src='/Round Corner Logo0 (1).png'
          width={150} height={51}
          alt="logo"
          style={{ background: '#a20000', borderRadius: '16px' }} />

      </div>

      <button aria-label='menu' onClick={handleToggle} className="d-block d-lg-none border rounded p-1">
        <IoMenuOutline size={30} />
      </button>


      <Navbar.Collapse id="responsive-navbar-nav" className="mt-2 custom-border-top">
        <Nav
          className="me-auto navigation d-flex align-items-center align-items-custom"
          id="navbartop"
          style={{ fontSize: "18px", width: "100%" }}
        >
          <Link to="/" onClick={handleClick} className="nav-link" style={{ fontSize: '15px' }}>Home</Link>
          <Link to="/aboutus" onClick={handleClick} className="nav-link" style={{ fontSize: '15px' }}>About Us</Link>
          <div className="dropdown">
            <Link to="#pricing" className="dropdown-link nav-link" style={{ fontSize: '15px' }}>
              Solar Modules{" "}
              <span>
                <MdOutlineKeyboardArrowDown />
              </span>
            </Link>
            <div className="dropdown-content p-1 rounded">
              <div className="dropdown-item p-1 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap' }}>
                <Link to="/topcon" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  N-Type TOPCon Solar Modules
                </Link>
              </div>
              {/* <hr /> */}
              <div className="dropdown-item p-1 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>
                <Link to="/mono" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  Mono PERC Solar Modules
                </Link>
              </div>
            </div>
          </div>

          <div className="dropdown">
            <Link to="#pricing" className="dropdown-link nav-link" style={{ fontSize: '15px' }}>
              Solar Power Plant{" "}
              <span>
                <MdOutlineKeyboardArrowDown />
              </span>
            </Link>
            <div className="dropdown-content p-1 rounded ">
              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap' }}>
                <Link to="/solarplants" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  Solar Power Plant
                </Link>
              </div>
              {/* <hr /> */}
              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>
                <Link to="/kusum" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  PM-Kusum-Yojna
                </Link>
              </div>
            </div>
          </div>
          {/* <Link to="/solarplants" onClick={handleClick} className="nav-link">Solar Power Plant</Link> */}

          <Link to="/blog" onClick={handleClick} className="nav-link" style={{ fontSize: '15px' }}>Blog</Link>
          {/* <Link to="/rei" onClick={handleClick} className="nav-link" style={{ fontSize: '15px', position: 'relative' }}>
            REI 2025
          </Link> */}

          <Link to="/contactus" onClick={handleClick} className="nav-link" style={{ fontSize: '15px' }}>Contact Us</Link>

          <div className="dropdown">
            <Link to="#pricing" className="dropdown-link nav-link" style={{ fontSize: '15px' }}>
              Resources{" "}
              <span>
                <MdOutlineKeyboardArrowDown />
              </span>
            </Link>
            <div className="dropdown-content p-2 rounded">
              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap' }}>
                <Link to="/quality" style={{ fontSize: "14px" }} onClick={handleClick} className="nav-link ">Quality Certificate</Link>
              </div>

              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap' }}>
                <Link to="/media" onClick={handleClick} className="nav-link" style={{ fontSize: '14px' }}>Media</Link>
              </div>

              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap' }}>
                <Link to="/csr" onClick={handleClick} className="nav-link" style={{ fontSize: '14px' }}>CSR</Link>
              </div>

              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: 'pre-wrap' }}>
                <Link to="/whitepaper" onClick={handleClick} className="nav-link" style={{ fontSize: '14px' }}>White Paper</Link>
              </div>

            </div>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;
